<template>
  <div class="video-wrapper">
    <!-- TCPlayer 拉流容器：永远渲染，不被 v-if 销毁（防止 TCPlayer.dispose 释放腾讯云通道） -->
    <div class="mainscreen-pull" :class="{ 'mainscreen-pull--hidden': !hasPullUrl }">
      <video
        class="zb-video"
        :id="playerId"
        preload="auto"
        playsinline
        webkit-playsinline
        style="object-fit: cover;"
      ></video>
      <div class="mainscreen-video-cover" v-if="!isPlaying">
        <div class="mainscreen-video-cover-box">
          <img class="mainscreen-video-cover-img" :src="mainScreenData && mainScreenData.userInfo && mainScreenData.userInfo.headPortrait" alt="" />
        </div>
      </div>
    </div>
    <!-- 摄像头关闭或无拉流地址时的占位图（用 v-show 切换，video 容器始终存在） -->
    <div class="mainscreen-bg" v-show="!hasPullUrl">
      <img class="mainscreen-bg-img" :src="mainScreenData && mainScreenData.userInfo && mainScreenData.userInfo.headPortrait" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "mainscreenplayer",
  props: {
    mainScreenData: {
      type: Object,
      default: null
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    selfUserId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      player: null,
      playerId: null,
      isPlaying: false,
      licenseUrl: "https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license"
    };
  },
  watch: {
    mainScreenData: {
      immediate: true,
      handler(newVal) {
        this.$nextTick(() => {
          this.initPlayer();
        });
      }
    }
  },
  computed: {
    hasPullUrl() {
      return this.mainScreenData 
        && this.mainScreenData.pullUrl 
        && this.mainScreenData.cameraStatus !== 0;
    }
  },
  beforeDestroy() {
    this._teardown();
  },
  methods: {
    _teardown() {
      if (this.player) {
        try {
          this.player.pause();
          this.player.src('');
          this.player.dispose();
        } catch (e) {
          console.warn('播放器清理异常:', e);
        }
        this.player = null;
      }
      this.playerId = null;
      this._lastSrc = null;
    },
    initPlayer() {
      if (!this.hasPullUrl) {
        // 没有有效拉流地址：只 pause 播放器（保留实例和通道），绝不 dispose
        if (this.player) {
          try { this.player.pause(); } catch (e) {}
        }
        this._lastSrc = null;
        this.isPlaying = false;
        return;
      }

      // 同一个流地址不重复初始化（mounted 和 immediate watcher 各触发一次）
      if (this._lastSrc === this.mainScreenData.pullUrl && this.player) {
        return;
      }
      this._lastSrc = this.mainScreenData.pullUrl;

      if (!this.playerId) {
        this.playerId = 'mainscreen-player-' + Date.now();
      }

      this.$nextTick(() => {
        if (!document.getElementById(this.playerId)) {
          console.warn('mainscreenplayer 容器不存在:', this.playerId);
          return;
        }

        if (!this.player) {
          this.player = TCPlayer(this.playerId, {
            sources: [{ src: this.mainScreenData.pullUrl }],
            licenseUrl: this.licenseUrl,
            autoplay: true,
            controls: false,
            playsinline: true,
            posterImage: false,
            bigPlayButton: false,
            webrtcConfig: {
              connectRetryCount: 999999,
            },
          });

          this.player.on('webrtcevent', (event) => {
            if (event.data.code == 1005 || event.data.code == 1009) {
              this.isPlaying = false;
            }
            if (event.data.code == 1003) {
              this.isPlaying = true;
            }
          });

          this.player.on('play', () => { this.isPlaying = true; });
          this.player.on('playing', () => { this.isPlaying = true; });
          this.player.on('loadeddata', () => { this.isPlaying = true; });

          // 兜底：500ms 后如果还没收到 playing 事件，强制显示画面（避免一直盖着封面）
          setTimeout(() => {
            if (!this.isPlaying) this.isPlaying = true;
          }, 500);
        } else {
          // player 已存在但 pullUrl 变了：更新地址继续播放，不销毁重建
          try {
            const currentSrc = typeof this.player.currentSrc === 'function' ? this.player.currentSrc() : '';
            if (currentSrc !== this.mainScreenData.pullUrl) {
              this.player.src(this.mainScreenData.pullUrl);
              this.player.play();
            } else {
              // 地址没变但之前被 pause 了：恢复播放
              this.player.play();
            }
          } catch (e) {
            console.warn('mainscreenplayer 更新地址失败:', e);
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.video-wrapper {
  height: 100%;
  aspect-ratio: 9 / 16;
  position: relative;
  overflow: hidden;
}

.mainscreen-pull {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.mainscreen-pull--hidden {
  visibility: hidden;
  pointer-events: none;
}

.mainscreen-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mainscreen-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.zb-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 98;
}

.mainscreen-video-cover {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 97;
}

.mainscreen-video-cover-box {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mainscreen-video-cover-img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
<style>
.video-wrapper video {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.video-wrapper video::-webkit-media-controls {
  display: none !important;
}

.video-wrapper video::-webkit-media-controls-enclosure {
  display: none !important;
}

.video-wrapper video::-webkit-media-controls-panel {
  display: none !important;
}

.video-wrapper button,
.video-wrapper .vjs-big-play-button,
.video-wrapper .tcp-big-play-button,
.video-wrapper .vjs-control-bar {
  display: none !important;
  pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// mainscreenplayer.vue?2f198657